import { render, staticRenderFns } from "./2dtype.vue?vue&type=template&id=48447052&scoped=true"
import script from "./2dtype.vue?vue&type=script&lang=js"
export * from "./2dtype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48447052",
  null
  
)

export default component.exports